module.exports = "/_next/static/images/596c38b97f18bde6e781ed751ac25060-slide-cajita-turbo.png";